export enum TeamMembersEnum {
  OPS_UPSELL = 'Ops Upsell',
}
export const TeamMemberCalendarLinks: Record<TeamMembersEnum, string> = {
  [TeamMembersEnum.OPS_UPSELL]:
    'https://meetings.hubspot.com/spencer318/consultation-with-commenda',
};
